import { useMemo } from "react";
import { ChartConfig } from "../components/chartV2/chart.typings";
import { WidgetDashboardConfig } from "../components/widgetDashboard/widgetDashboard.interface";

export const getChartConfigsForLayout = (
    activeLayoutId: string,
    activeLayout: WidgetDashboardConfig | undefined,
    configs: Record<string, ChartConfig>
): Record<string, ChartConfig> =>
    Object.entries(activeLayout?.widgets ?? {}).reduce((acc, [, widget]) => {
        const chartId = `${activeLayoutId}-${widget.slotId}`;
        acc[chartId] = configs[chartId];
        return acc;
    }, {} as Record<string, ChartConfig>);

export const useChartConfigs = (activeLayoutId: string, activeLayout: WidgetDashboardConfig, configs: Record<string, ChartConfig>) => {
    return useMemo(
        () => getChartConfigsForLayout(activeLayoutId, activeLayout, configs),
        [activeLayout, configs, activeLayoutId]
    );
};